import {Component, ElementRef, OnInit, AfterViewInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";

/**
 * @var __showKiSelection used to store that visibility status of the ki selection
 */
declare let __showKiSelection;

/**
 * Special component for the start page of the chapter "verbrauchsanalyse". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-heizcheck-heizkostenabrechnung-start',
    templateUrl: './heizkostenabrechnung.start.component.html',
    standalone: false
})
export class HeizkostenabrechnungStartComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * toggle for the KI selection part
   */
  showKiSelection: boolean = false;

  /**
   * construct
   * @param stepService
   * @param router
   * @param elementService
   * @param heizcheckRequestService
   * @param element
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected heizcheckRequestService: HeizcheckRequestService,
              protected element:ElementRef) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // create global variable to store the toggle status
    if(typeof __showKiSelection === "undefined") {
      window['__showKiSelection'] = false;
    }
    else {
      this.showKiSelection = __showKiSelection;
    }

    // put some data from base input object into teh input object of the energy bill
    const anfrage = this.heizcheckRequestService.getAnfrage();

    ['nutzungstyp', 'gebaeudetyp', 'heizungstyp'].forEach(field => {
      anfrage.heizkostenanalyseInput[field] = anfrage.verbrauchsanalyseInput[field];
    });
    this.heizcheckRequestService.setAnfrage(anfrage);
  }

  /**
   * toggle the ki selection wrapper
   */
  toggleKiSelection(): void {
    this.showKiSelection = !this.showKiSelection;
    __showKiSelection = this.showKiSelection;
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element);

    // init tooltips
    this.elementService.initTooltips(this.element);
  }
}
